import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useSnippetNames } from '../hooks/useSnippetNames';

type SnippetNamesContextState = {
  snippetNames: string[];
  isLoading: boolean;
};

const defaultState: SnippetNamesContextState = {
  snippetNames: [],
  isLoading: false,
};

const SnippetNamesContext = createContext(defaultState);

export const SnippetNamesContextProvider: FC<PropsWithChildren<NonNullable<unknown>>> = ({
  children,
}) => {
  const { isLoading, snippetNames } = useSnippetNames();
  return (
    <SnippetNamesContext.Provider value={{ isLoading, snippetNames }}>
      {children}
    </SnippetNamesContext.Provider>
  );
};

export const useSnippetNamesContext = () => useContext(SnippetNamesContext);
